module.exports = __webpack_public_path__ + "static/img/banner2.f99d9da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner2.png
// module id = pMVX
// module chunks = 12